module.exports = __webpack_public_path__ + "img/flow-chart.0f50bbfb.jpg";